const sectionTab = document.querySelectorAll('.sidebar-menu-container-section-tab');
sectionTab[7].classList.add('sidebar-menu-container-section-tab--active');

const objContext = JSON.parse(sessionStorage.getItem("context"));
if (objContext == null || objContext.store_name == null)
    location.href = 'index.html';
var id_current_store = null, url_picture = null, objOrdersTable = null, url_background = null;


const containerSlidesAdded = document.querySelector(".slide-added-container"),
    fileInput = document.querySelector('#loadMedia'),
    previewName = document.querySelector('.preview-name'),
    previewImage = document.querySelector('.preview-image'),
    btnAddSlide = document.querySelector("#addSlide"),
    btnAddBackGrounds = document.querySelector('#addBackground'),
    divCurrentBackground = document.querySelector('#img-current-background'),
    background_defaults = document.querySelectorAll('.admin-background-item');
let isEmptyBakcground = true;


{/* <div class="slide-item-image" style="background: url(); justify-content: normal"></div> */ }
let layoutSlidesAdded = `
    <div class="slide-item">
        <figure class="slide-item-preview">
                __OBJECT__

            <div class="delete-button" onclick="deleteSlide('__IMAGE_URL__');">
                <span class="icon-trash" title="Eliminar slider"></span>
            </div>
        </figure>
        <figcaption class="slide-item-preview-caption">
            <span>__CAPTION__</span>
        </figcaption>
    </div>
`;


document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';

window.addEventListener("load", loadPage);
function loadPage() {
    id_current_store = localStorage.getItem("currentStore");
    UI.hideLoader();

    if (id_current_store == null || objContext == null)
        location.href = 'index.html';
    else {
        document.querySelector('.sidebar-profile-img img').src = objContext.store_image
        document.querySelector('.sidebar-profile-name-store').innerHTML = objContext.store_name.replace(/\\/, '');

        loadStoreInfo();
    }
}

function loadStoreInfo() {
    UI.showLoader();

    fetch(
        BASE_URLS.Dinny.api + `/stores-slider?store_id=${id_current_store}&req_id=${new Date().getTime()}`,
        {
            credentials: 'include'
        }
    ).then(function (response) {
        if (response.ok) {
            UI.hideLoader();

            response.json().then(function (json) {
                console.log(json);
                objOrdersTable = json;

                if (divCurrentBackground) {
                    if (objOrdersTable.hasOwnProperty('image_background')) {
                        document.querySelector('.profile-form-der').style.display = "grid";
                        isEmptyBakcground = false;
                        divCurrentBackground.innerHTML = "<img src='" + objOrdersTable.image_background + "' style='width:100%;height:100%' />";
                    }
                }
                else {
                    if (objOrdersTable.hasOwnProperty('slider') && objOrdersTable.slider.length > 0) {
                        document.querySelector('.profile-form-der').style.display = "grid";
                        isEmptyBakcground = false;

                        objOrdersTable.slider.forEach((picture) => {
                            let name = picture.split("/").pop();

                            containerSlidesAdded.insertAdjacentHTML('beforeend',
                                layoutSlidesAdded
                                    .replace(/__IMAGE_URL__/g, picture)
                                    .replace(/__CAPTION__/g, name)
                                    .replace(/__OBJECT__/g, picture.indexOf('.mp4') != -1 ? '<video src="' + picture + '" controls style="width:100%; margin-right:20px"></video>' : '<img src="' + picture + '" style="width:100%; margin-right:20px" />'))
                        });
                    }
                }
            });
        } else {
            response.json().then(function (content) {
                if (403 == response.status) {
                    window.location.href = 'login.html'
                } else {
                    UI.hideLoader();
                }
            })
        }
    }).catch(function () { UI.hideLoader() });
}

function selectBackground(element) {
    console.log(element.style.background);
    element.style.border = "solid 3px #5ABB6E";
}

if (background_defaults)
    background_defaults.forEach((element) => {
        element.addEventListener('click', (e) => {
            clearDefaultBackground();
            e.target.style.border = "solid 3px #5ABB6E";
            url_background = e.target.src;
            console.log(url_background);
        });
    });

function clearDefaultBackground() {
    background_defaults.forEach((item) => {
        item.querySelector('img').style.border = "solid 3px white";
    });
    url_background = null;
}

function previewPicture(e) {
    let outPut = document.querySelector('.preview-image');
    outPut.innerHTML = "";
    let outPutImage = document.createElement("img");
    outPutImage.src = URL.createObjectURL(e.target.files[0]);
    outPutImage.onload = function () {
        URL.revokeObjectURL(outPutImage.src) // free memory

        if (this.width >= 500 && this.height >= 500) {
            if (e.target.files[0].size < 4096000) {
                outPut.appendChild(outPutImage);
                outPut.style.display = "block";
                clearDefaultBackground();
            }
            else {
                UI.message({ title: 'Error al cargar imagen', content: 'Por favor, selecciona una imagen de menos de 4MB.', accept: 'Aceptar' });
                e.target.value = "";
            }
        }
        else {
            UI.message({ title: 'Error al cargar imagen', content: 'Por favor, selecciona una imagen de al menos 500 por 500 pixeles.', accept: 'Aceptar' });
            e.target.value = "";
        }
    }
}

if (btnAddBackGrounds)
    btnAddBackGrounds.addEventListener('click', (e) => {
        if (url_background != null && url_background.length > 0) {
            UI.showLoader();
            change_background(url_background);
        }
        else {
            let selectedImage = document.getElementById('background-img').files[0];
            if (selectedImage == null || selectedImage === "undefined") {
                if (isEmptyBakcground) {
                    UI.message({ title: 'Faltan datos', content: 'No guardaste una imagen de fondo, selecciona una.', accept: 'Aceptar' });
                    return;
                }

                else {
                    UI.message({ title: 'Faltan datos', content: 'Selecciona una imagen de fondo.', accept: 'Aceptar' });
                    return;
                }

            }

            UI.showLoader();
            let objReader = new FileReader();
            objReader.readAsDataURL(selectedImage);
            objReader.onload = function (e) {
                let base64string = e.target.result;
                base64string = base64string.replace(base64string.substring(0, base64string.indexOf(',') + 1), "");

                fetch(
                    BASE_URLS.Standalone.api + '/picture',
                    {
                        method: 'POST',
                        body: JSON.stringify({
                            key: 'delivery_screen/establishments/' + id_current_store + '/background/' + new Date().toISOString().replace(/:/g, '').replace(/-/g, '').replace(/\./g, '') + '.' + selectedImage.name.split('.').pop(),
                            content: base64string,
                            contentType: selectedImage.type
                        }),
                        credentials: 'include'
                    }).then(function (response) {
                        if (response.ok) {
                            response.json().then(function (picture_url) {
                                change_background(picture_url);
                            });
                        } else {
                            response.json().then(function (content) {
                                if (403 == response.status) {
                                    window.location.href = 'login.html'
                                } else {
                                    UI.hideLoader();
                                    UI.message({ title: 'Ocurrió un error', content: 'Ocurrió un error al guardar la imagen.', accept: 'Aceptar' });
                                }
                            });
                        }
                    }).catch(function (e) {
                        UI.hideLoader();
                        UI.message({ title: 'Ocurrió un error', content: 'Ocurrió un error al guardar la imagen.', accept: 'Aceptar' });
                        console.log(e);
                    });
            }
        }
    });

if (fileInput)
    fileInput.addEventListener("change", (e) => {
        previewImage.classList.add("hide");
        previewName.textContent = "";

        let fileType = e.target.files[0].type;
        if (fileType == "image/jpeg" || fileType == "image/jpg" || fileType == "image/png" || fileType == "video/mp4") {
            let outPut = document.querySelector('.preview-image');
            outPut.innerHTML = "";
            console.log(e.target.files[0]);
            let outPutObject = fileType.indexOf('image') != -1 ? document.createElement("img") : document.createElement("video");
            outPutObject.src = URL.createObjectURL(e.target.files[0]);
            if (fileType == "video/mp4") {
                if (e.target.files[0].size < 10485760) {
                    outPutObject.setAttribute('controls', '');
                    outPutObject.style.width = "100%";
                    outPut.appendChild(outPutObject);

                    previewImage.classList.remove("hide");
                    previewName.textContent = e.target.files[0].name;

                }
                else {
                    UI.message({ title: 'Error al cargar video', content: 'Por favor, selecciona un video de menos de 10 MB.', accept: 'Aceptar' });
                    e.target.value = "";
                }
            }
            else {
                outPutObject.onload = function () {
                    URL.revokeObjectURL(outPutObject.src) // free memory

                    if (this.width >= 1310 && this.height >= 840) {
                        if (e.target.files[0].size < 4194304) {
                            outPut.appendChild(outPutObject);

                            previewImage.classList.remove("hide");
                            previewName.textContent = e.target.files[0].name;

                        }
                        else {
                            UI.message({ title: 'Error', content: 'Por favor, selecciona una imagen de menos de 4MB.', accept: 'Aceptar' });
                            e.target.value = "";
                        }
                    }
                    else {
                        UI.message({ title: 'Error', content: 'Por favor, selecciona una imagen de al menos 1310x840 pixeles.', accept: 'Aceptar' });
                        e.target.value = "";
                    }
                }
            }
        }
        else {
            UI.message({ title: 'Error', content: 'Por favor, seleccion un archivo jpg, png o mp4.', accept: 'Aceptar' });
            e.target.value = "";
        }
    });

function change_background(img_url) {
    fetch(
        BASE_URLS.Dinny.api + '/stores-slider/change_background?store_id=' + id_current_store,
        {
            method: 'POST',
            body: JSON.stringify({
                image_background: img_url
            }
            ),
            credentials: 'include'
        }).then(function (response) {

            if (response.ok) {
                location.reload();
            } else {
                UI.hideLoader();
                UI.message({ title: 'Ocurrió un error', content: 'No se pudo cambiar la imagen.', accept: 'Aceptar' });
            }
        }).catch(function (error) {
            UI.hideLoader();
            UI.message({ title: 'Ocurrió un error', content: 'Ocurrió un error al cambiar la imagen.', accept: 'Aceptar' });
            console.log(error);
        })
}

if (btnAddSlide)
    btnAddSlide.addEventListener('click', (e) => {
        let selectedObject = document.getElementById('loadMedia').files[0];

        if (selectedObject == null || selectedObject === "undefined") {
            UI.message({ title: 'Faltan datos', content: 'No guardaste una imagen o video para el slider, carga alguno.', accept: 'Aceptar' });
            return;
        }

        UI.showLoader();

        let objReader = new FileReader();
        objReader.readAsArrayBuffer(selectedObject);
        objReader.addEventListener('loadend', function (e) {
            fetch(
                BASE_URLS.Dinny.api + '/stores-slider/request_upload_url?store_id=' + id_current_store,
                {
                    method: 'POST',
                    body: JSON.stringify({
                        key: 'delivery_screen/establishments/' + id_current_store + '/slider/' + new Date().toISOString().replace(/:/g, '').replace(/-/g, '').replace(/\./g, '') + '.' + selectedObject.name.split('.').pop(),
                        contentType: selectedObject.type
                    }),
                    credentials: 'include'
                }
            ).then(function (response) {
                if (response.ok) {
                    response.json().then(function (objectURL) {
                        console.log(objectURL);
                        fetch(objectURL, {
                            method: "PUT",
                            body: new Blob([objReader.result], { type: selectedObject.type })
                        })
                            .then(function (response) {
                                if (response.ok) {
                                    let objectURL = new URL(response.url);

                                    fetch(
                                        BASE_URLS.Dinny.api + '/stores-slider/add_slider?store_id=' + id_current_store,
                                        {
                                            method: 'POST',
                                            body: JSON.stringify({
                                                image_slider: objectURL.origin + objectURL.pathname
                                            }),
                                            credentials: 'include'
                                        }).then(function (response) {
                                            if (response.ok) {
                                                location.reload();
                                            } else {
                                                UI.hideLoader();
                                                UI.message({ title: 'Ocurrió un error', content: 'No se pudo agregar el slider.', accept: 'Aceptar' });
                                            }
                                        }).catch(function (error) {
                                            UI.hideLoader();
                                            UI.message({ title: 'Ocurrió un error', content: 'Ocurrió un error al agregar el slider.', accept: 'Aceptar' });
                                            console.log(error);
                                        });
                                }
                                else {
                                    UI.hideLoader();
                                    UI.message({ title: 'Ocurrió un error', content: 'No se pudo agregar el slider.', accept: 'Aceptar' });
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                                UI.hideLoader();
                                UI.message({ title: 'Ocurrió un error', content: 'No se pudo agregar el slider.', accept: 'Aceptar' });
                            });
                    });
                } else {
                    response.json().then(function (content) {
                        if (403 == response.status) {
                            window.location.href = 'login.html'
                        } else {
                            UI.hideLoader();
                            UI.message({ title: 'Ocurrió un error', content: 'Ocurrió un error al guardar el objeto.', accept: 'Aceptar' });
                        }
                    });
                }
            })
        });
    });

function deleteSlide(img_url) {
    UI.confirm({
        title: 'Eliminar slider',
        content: '¿Está seguro de eliminar este slider?',
        cancel: 'Cancelar',
        accept: 'Aceptar'
    }, function (response) {
        if (response) {
            UI.showLoader()
            fetch(
                BASE_URLS.Dinny.api + '/stores-slider/delete_slider?store_id=' + id_current_store,
                {
                    method: 'POST',
                    body: JSON.stringify({
                        image_slider: img_url
                    }
                    ),
                    credentials: 'include'
                }).then(function (response) {

                    if (response.ok) {
                        location.reload();
                    } else {
                        UI.hideLoader();
                        UI.message({ title: 'Ocurrió un error', content: 'No se pudo eliminar la imagen.', accept: 'Aceptar' });
                    }
                }).catch(function (error) {
                    UI.hideLoader();
                    UI.message({ title: 'Ocurrió un error', content: 'Ocurrió un error al eliminar la imagen.', accept: 'Aceptar' });
                    console.log(error);
                })
        }
    });
}